export {
  default as speakers,
  ReactComponent as Speakers,
} from '@assets/icons/features-and-amenities/speakers.svg'    
